// Simple similarity scoring for Omada hostname ↔ existing asset name/tag/serial.
// - Case & non-alphanumeric insensitive
// - Direct substring inclusion → very high score
// - Shared 4+ char alnum stem (e.g. "SEN062") → high score
// - Otherwise Dice bigram coefficient
// Returns 0..1 (>= 0.55 recommended as suggestion threshold).

const norm = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9\u3040-\u30ff\u4e00-\u9fff]+/g, '');

const bigrams = (s) => {
  const set = new Set();
  for (let i = 0; i < s.length - 1; i += 1) set.add(s.slice(i, i + 2));
  return set;
};

const dice = (a, b) => {
  if (!a || !b) return 0;
  const A = bigrams(a); const B = bigrams(b);
  if (A.size === 0 || B.size === 0) return a === b ? 1 : 0;
  let inter = 0;
  A.forEach((g) => { if (B.has(g)) inter += 1; });
  return (2 * inter) / (A.size + B.size);
};

// Extract "identifier stems" — runs of 4+ alnum chars (e.g. "SEN062", "IT001", "MACBOOK").
const stemsOf = (s) => {
  const out = [];
  const re = /[a-z0-9]{4,}/gi;
  let m;
  while ((m = re.exec(String(s || ''))) !== null) out.push(m[0].toLowerCase());
  return out;
};

export function scoreMatch(omadaName, asset) {
  if (!omadaName) return 0;
  const target = norm(omadaName);
  if (!target) return 0;
  const candidates = [asset.name, asset.asset_tag, asset.serial].map(norm).filter(Boolean);
  if (candidates.length === 0) return 0;

  // 直接包含
  const contains = candidates.some((c) => c.includes(target) || target.includes(c));
  if (contains) return 0.95;

  // 4+ 文字の識別子共有
  const omadaStems = stemsOf(omadaName);
  const assetStems = [asset.name, asset.asset_tag, asset.serial].flatMap(stemsOf);
  const shared = omadaStems.some((os) => assetStems.some((as) => as === os || as.includes(os) || os.includes(as)));
  if (shared) return 0.85;

  // Dice 係数の最大値
  let best = 0;
  candidates.forEach((c) => { best = Math.max(best, dice(target, c)); });
  return best;
}

export function suggestMatches(omadaName, assets, { limit = 4, threshold = 0.55 } = {}) {
  if (!omadaName) return [];
  return assets
    .map((a) => ({ asset: a, score: scoreMatch(omadaName, a) }))
    .filter((r) => r.score >= threshold)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit);
}
